import { CircularVideoPlayer } from "./circular-video-player"
import useControlProductTour from "../hooks/use-controls"
import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { useProductTourV2 } from "../stores/use-product-tour"
import { PRODUCT_TOUR_V2_STEPS } from "../types/steps"
import { useAuth } from "@/modules/auth/store"
import mixpanelClient from "@/services/mixpanel"
import { useCosmos } from "@/modules/cosmos/stores/use-cosmos-store"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"

interface VideoMiniModalProps {
  size?: number
}

export const VideoMiniModal = ({ size = 280 }: VideoMiniModalProps) => {
  const { videoUrl } = useControlProductTour()
  const [showContinueButton, setShowContinueButton] = useState(false)
  const location = useLocation()
  const { currentStep, setIsActive } = useProductTourV2()
  const { setProductTourStatus, user } = useAuth()
  const { cosmosKey } = useCosmos()
  const navigate = useNavigate()

  // Show continue button after 5 seconds if in step 2 and on my-situation page
  useEffect(() => {
    if (
      currentStep === PRODUCT_TOUR_V2_STEPS.MY_SITUATION &&
      location.pathname === "/my-situation"
    ) {
      const timer = setTimeout(() => {
        setShowContinueButton(true)
      }, 5000)

      return () => clearTimeout(timer)
    } else {
      setShowContinueButton(false)
    }
  }, [currentStep, location.pathname])

  const handleContinueStudying = () => {
    mixpanelClient.productTour.pressContinueStudying({
      email: user.emailAddress,
      name: `${user.firstName} ${user.lastName}`,
      organization: cosmosKey,
    })
    setProductTourStatus("completed")
    setIsActive(false)
    navigate("/study")
  }

  return (
    <div
      className={cn(
        "fixed z-50",
        currentStep === PRODUCT_TOUR_V2_STEPS.MY_SITUATION && "bottom-4 right-4",
        currentStep === PRODUCT_TOUR_V2_STEPS.STUDY && "right-4 top-4",
      )}
    >
      <div style={{ width: `${size}px`, height: `${size}px` }}>
        <CircularVideoPlayer videoUrl={videoUrl} size={size} showControls={true} />
      </div>

      {showContinueButton && (
        <div className="mt-3 flex justify-center">
          <Button onClick={handleContinueStudying}>Continuar estudiando</Button>
        </div>
      )}
    </div>
  )
}
